import React from 'react'

import s from '../NotFound.module.scss'

const Box = () => {
	return (
		<g
			id={s.box}
			data-name='Layer 9'
		>
			<g id={s.boxtop}>
				<polygon
					className={s.cls8}
					points='569.71 382.28 653.74 329.39 747.13 320.1 679.2 369.85 569.71 382.28'
				></polygon>
				<polygon
					className={s.cls5}
					points='691.95 367.2 570.87 392.34 565.32 383.35 687.8 357.45 691.95 367.2'
				></polygon>

				<polygon
					className={s.cls5}
					points='661.54 337.48 570.87 392.34 562.42 378.92 652.25 322.38 658.12 321.34 661.54 337.48'
				></polygon>
				<polygon
					className={s.cls7}
					points='661.54 337.48 570.87 392.34 562.42 378.92 652.25 322.38 658.12 321.34 661.54 337.48'
				></polygon>
				<polygon
					className={s.cls5}
					points='747.13 320.1 661.54 337.48 652.25 322.38 738.4 307.1 747.13 320.1'
				></polygon>
			</g>
			<path
				className={s.cls5}
				d='M588.28,420.26s3.44,5.2,5.19,8l43.1,68.48,158.81-100-43.1-68.48q-2.63-4.17-5.47-8Z'
			></path>
			<path
				className={s.cls7}
				d='M588.28,420.26s3.44,5.2,5.19,8l43.1,68.48,158.81-100-43.1-68.48q-2.63-4.17-5.47-8Z'
			></path>
			<rect
				className={s.cls5}
				x='693.73'
				y='335.51'
				width='83.99'
				height='90.58'
				transform='translate(-89.78 450.43) rotate(-32.19)'
			></rect>
		</g>
	)
}

export default Box
